module.exports = __webpack_public_path__ + "img/deezer_823f9b5ff940eba3ff9ccb1deaf35775.longcache.png";